import { useExcursionCitySelectedTag } from './useExcursionCitySelectedTag';
import { useExcursionCityTagsAdapters } from './useExcursionCityTagsAdapters';
import { useExcursionCityTagsFiltering } from './useExcursionCityTagsFiltering';
import { useExcursionCityVisibleTags } from './useExcursionCityVisibleTags';
import type { Ref } from 'vue';
import type { CityTag, RegionTagUrls } from '@/shared/api/experience';

export function useExcursionCityRubrics(cityTags: Ref<CityTag[] | undefined>, isMobile: Ref<boolean>) {
  const context = computed(() => 'excursions' as keyof RegionTagUrls);

  const { selectedValue, cachedSelectedValue } = useExcursionCitySelectedTag(cityTags, context);
  const { popupTags, rubricsTags } = useExcursionCityTagsFiltering(cityTags);
  const { popupTagsMapped, rubricsAdapters } = useExcursionCityTagsAdapters(rubricsTags, popupTags, context);
  const { visibleTags } = useExcursionCityVisibleTags(rubricsAdapters, selectedValue, isMobile);

  return {
    selectedValue,
    cachedSelectedValue,
    popupTagsMapped,
    rubricsAdapters,
    visibleTags,
  };
}
